"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TierShape = exports.TierPreviewShape = exports.TierLimitShape = exports.ManagedApiInstancePropTypes = exports.ListItemShape = exports.ListItemPropTypes = exports.FilterListItemShape = exports.FilterListItemPropTypes = exports.ContractShape = exports.ContractPropTypes = exports.ContractApiShape = exports.ContractApiGroupShape = exports.ApplicationShape = exports.ApiInstanceShape = exports.ApiInstancePropTypes = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ApplicationShape = exports.ApplicationShape = _propTypes.default.shape({
  id: _propTypes.default.number.isRequired,
  name: _propTypes.default.string.isRequired,
  clientId: _propTypes.default.string.isRequired,
  clientSecret: _propTypes.default.string.isRequired,
  masterOrganizationId: _propTypes.default.string.isRequired,
  descripton: _propTypes.default.string,
  url: _propTypes.default.string,
  redirectUri: _propTypes.default.arrayOf(_propTypes.default.string),
  grantTypes: _propTypes.default.arrayOf(_propTypes.default.string)
});
var ListItemPropTypes = exports.ListItemPropTypes = {
  id: _propTypes.default.number.isRequired,
  text: _propTypes.default.string.isRequired,
  subtext: _propTypes.default.string.isRequired,
  pillText: _propTypes.default.string.isRequired,
  isDisabled: _propTypes.default.bool,
  disabledReason: _propTypes.default.string,
  selected: _propTypes.default.bool.isRequired,
  color: _propTypes.default.string.isRequired
};
var ListItemShape = exports.ListItemShape = _propTypes.default.shape(ListItemPropTypes);
var FilterListItemPropTypes = exports.FilterListItemPropTypes = _objectSpread(_objectSpread({}, ListItemPropTypes), {}, {
  itemGroupId: _propTypes.default.string.isRequired,
  itemGroupName: _propTypes.default.string.isRequired
});
var FilterListItemShape = exports.FilterListItemShape = _propTypes.default.shape(FilterListItemPropTypes);
var TierLimitShape = exports.TierLimitShape = _propTypes.default.shape({
  maximumRequests: _propTypes.default.number.isRequired,
  period: _propTypes.default.number.isRequired,
  unit: _propTypes.default.string.isRequired
});
var TierPreviewShape = exports.TierPreviewShape = _propTypes.default.shape({
  apiId: _propTypes.default.number.isRequired,
  displayName: _propTypes.default.string.isRequired,
  limits: _propTypes.default.arrayOf(TierLimitShape).isRequired,
  isApplied: _propTypes.default.bool.isRequired
});
var TierShape = exports.TierShape = _propTypes.default.shape({
  id: _propTypes.default.number.isRequired,
  name: _propTypes.default.string.isRequired,
  contractId: _propTypes.default.number.isRequired,
  approval: _propTypes.default.oneOf(['MANUAL', 'AUTOMATIC']).isRequired,
  compareToActual: _propTypes.default.oneOf(['LESS RESTRICTIVE', 'MORE RESTRICTIVE']),
  limits: _propTypes.default.arrayOf(TierLimitShape),
  limitsByApi: _propTypes.default.arrayOf(_propTypes.default.shape({
    apiId: _propTypes.default.number.isRequired,
    limits: _propTypes.default.arrayOf(TierLimitShape)
  }).isRequired)
});
var ContractApiGroupShape = exports.ContractApiGroupShape = _propTypes.default.shape({
  id: _propTypes.default.number.isRequired,
  assetVersion: _propTypes.default.string.isRequired,
  environmentId: _propTypes.default.string.isRequired
});
var ContractApiShape = exports.ContractApiShape = _propTypes.default.shape({
  id: _propTypes.default.number.isRequired,
  assetVersion: _propTypes.default.string.isRequired
});
var ContractPropTypes = exports.ContractPropTypes = {
  id: _propTypes.default.number.isRequired,
  status: _propTypes.default.oneOf(['APPROVED', 'PENDING', 'REVOKED', 'REJECTED']).isRequired,
  assetName: _propTypes.default.string.isRequired,
  versionGroup: _propTypes.default.string,
  isApplied: _propTypes.default.bool.isRequired,
  tier: TierShape,
  requestedTier: TierShape,
  alternativeTiers: _propTypes.default.arrayOf(TierShape).isRequired,
  type: _propTypes.default.oneOf(['API Group', 'Standalone']),
  apiInstance: ContractApiShape,
  apiGroupInstance: ContractApiGroupShape
};
var ContractShape = exports.ContractShape = _propTypes.default.shape(ContractPropTypes);
var BaseApiInstancePropTypes = {
  id: _propTypes.default.number.isRequired,
  name: _propTypes.default.string.isRequired,
  color: _propTypes.default.string.isRequired,
  assetName: _propTypes.default.string.isRequired,
  instanceName: _propTypes.default.string.isRequired,
  displayName: _propTypes.default.string.isRequired,
  environmentId: _propTypes.default.string.isRequired,
  environmentName: _propTypes.default.string.isRequired
};
var ApiInstancePropTypes = exports.ApiInstancePropTypes = _objectSpread(_objectSpread({}, BaseApiInstancePropTypes), {}, {
  apiVersion: _propTypes.default.string.isRequired
});
var ManagedApiInstancePropTypes = exports.ManagedApiInstancePropTypes = _objectSpread({}, BaseApiInstancePropTypes);
var ApiInstanceShape = exports.ApiInstanceShape = _propTypes.default.oneOfType([_propTypes.default.shape(ApiInstancePropTypes), _propTypes.default.shape(ManagedApiInstancePropTypes)]);
//# sourceMappingURL=types.js.map